let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bEb8c")).then(() => parcelRequire('5mSqI'));